import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  deleteVaultRequestByIdRequest,
  getBuyerContactListRequest,
  getVaultRequestListRequest,
  updateVaultRequestByIdRequest,
  updateBuyerContactByIdRequest,
  deleteBuyerContactByIdRequest,
  addNewBuyerContactRequest,
  addNewVaultRequest,
  getFilteredBuyerRecordsRequest,
  getFilteredSupplierRecordsRequest,
  addNewHyperlinkRequest,
  getSupplierSecretsRequest,
} from '../../utils/httpRequests';
import {
  DELETE_BUYER_CONTACT_FAILED,
  DELETE_BUYER_CONTACT_REQUESTED,
  DELETE_BUYER_CONTACT_SUCCESS,
  DELETE_VAULT_REQUEST_FAILED,
  DELETE_VAULT_REQUEST_REQUESTED,
  DELETE_VAULT_REQUEST_SUCCESS,
  GET_BUYER_CONTACT_LIST_FAILED,
  GET_BUYER_CONTACT_LIST_REQUESTED,
  GET_BUYER_CONTACT_LIST_SUCCESS,
  GET_VAULT_REQUEST_LIST_FAILED,
  GET_VAULT_REQUEST_LIST_REQUESTED,
  GET_VAULT_REQUEST_LIST_SUCCESS,
  UPDATE_VAULT_REQUEST_FAILED,
  UPDATE_VAULT_REQUEST_REQUESTED,
  UPDATE_VAULT_REQUEST_SUCCESS,
  ADD_NEW_BUYER_CONTACT_SUCCESS,
  ADD_NEW_BUYER_CONTACT_FAILED,
  ADD_NEW_BUYER_CONTACT_REQUESTED,
  ADD_NEW_VAULT_REQUEST_SUCCESS,
  ADD_NEW_VAULT_REQUEST_FAILED,
  ADD_NEW_VAULT_REQUEST_REQUESTED,
  UPDATE_BUYER_CONTACT_SUCCESS,
  UPDATE_BUYER_CONTACT_FAILED,
  UPDATE_BUYER_CONTACT_REQUESTED,
  GET_FILTERED_BUYER_RECORDS_SUCCESS,
  GET_FILTERED_BUYER_RECORDS_FAILED,
  GET_FILTERED_BUYER_RECORDS_REQUESTED,
  GET_FILTERED_SUPPLIER_RECORDS_SUCCESS,
  GET_FILTERED_SUPPLIER_RECORDS_FAILED,
  GET_FILTERED_SUPPLIER_RECORDS_REQUESTED,
  ADD_NEW_HYPERLINK_SUCCESS,
  ADD_NEW_HYPERLINK_FAILED,
  ADD_NEW_HYPERLINK_REQUESTED,
  GET_SUPPLIER_SECRETS_SUCCESS,
  GET_SUPPLIER_SECRETS_FAILED,
  GET_SUPPLIER_SECRETS_REQUESTED,
} from '../actions/actionTypes';
import {
  addNewHyperlink,
  getBuyerContactList,
  getVaultRequestList,
} from '../actions';
import { getIdToken, getErrorData } from '../../utils/helperFunctions';

// sagas
export function* getBuyerContactListSaga({
  payload: { contactSearchCriteria },
}) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      getBuyerContactListRequest,
      contactSearchCriteria,
      idToken,
    );
    yield put({
      type: GET_BUYER_CONTACT_LIST_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_BUYER_CONTACT_LIST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* getVaultRequestListSaga({
  payload: { vaultRequestSearchCriteria },
}) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      getVaultRequestListRequest,
      vaultRequestSearchCriteria,
      idToken,
    );
    yield put({
      type: GET_VAULT_REQUEST_LIST_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_VAULT_REQUEST_LIST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* deleteVaultRequestSaga({
  payload: { uuid, vaultRequestSearchCriteria },
}) {
  try {
    const idToken = yield getIdToken();
    yield call(deleteVaultRequestByIdRequest, uuid, idToken);
    yield put({
      type: DELETE_VAULT_REQUEST_SUCCESS,
      payload: { data: uuid },
    });
    yield put(getVaultRequestList(vaultRequestSearchCriteria));
  } catch (err) {
    yield put({
      type: DELETE_VAULT_REQUEST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* deleteBuyerContactSaga({
  payload: { uuid, buyerContactSearchCriteria },
}) {
  try {
    const idToken = yield getIdToken();
    yield call(deleteBuyerContactByIdRequest, uuid, idToken);
    yield put({
      type: DELETE_BUYER_CONTACT_SUCCESS,
      payload: { data: uuid },
    });
    yield put(getBuyerContactList(buyerContactSearchCriteria));
  } catch (err) {
    yield put({
      type: DELETE_BUYER_CONTACT_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* updateVaultRequestSaga({
  payload: {
    uuid,
    updateVaultRequestData,
    vaultRequestSearchCriteria,
    isEmailRequired,
  },
}) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      updateVaultRequestByIdRequest,
      uuid,
      updateVaultRequestData,
      idToken,
    );
    yield put({
      type: UPDATE_VAULT_REQUEST_SUCCESS,
      payload: { data },
    });
    if (isEmailRequired) {
      yield put(
        addNewHyperlink({
          vaultRequestId: uuid,
        }),
      );
    }
    yield put(getVaultRequestList(vaultRequestSearchCriteria));
  } catch (err) {
    yield put({
      type: UPDATE_VAULT_REQUEST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* addNewVaultRequestSaga({
  payload: { createVaultRequestData, isEmailRequired },
}) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      addNewVaultRequest,
      createVaultRequestData,
      idToken,
    );
    yield put({
      type: ADD_NEW_VAULT_REQUEST_SUCCESS,
      payload: { data },
    });
    if (isEmailRequired) {
      yield put(
        addNewHyperlink({
          vaultRequestId: data?.data?.id,
        }),
      );
    }
  } catch (err) {
    yield put({
      type: ADD_NEW_VAULT_REQUEST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* addNewBuyerContactSaga({
  payload: { data, buyerContactSearchCriteria },
}) {
  try {
    const idToken = yield getIdToken();
    const response = yield call(addNewBuyerContactRequest, data, idToken);
    yield put({
      type: ADD_NEW_BUYER_CONTACT_SUCCESS,
      payload: { data: response },
    });
    yield put(getBuyerContactList(buyerContactSearchCriteria));
  } catch (err) {
    yield put({
      type: ADD_NEW_BUYER_CONTACT_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* updateBuyerContactSaga({
  payload: { uuid, updateBuyerContactData, buyerContactSearchCriteria },
}) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      updateBuyerContactByIdRequest,
      uuid,
      updateBuyerContactData,
      idToken,
    );
    yield put({
      type: UPDATE_BUYER_CONTACT_SUCCESS,
      payload: { data },
    });
    yield put(getBuyerContactList(buyerContactSearchCriteria));
  } catch (err) {
    yield put({
      type: UPDATE_BUYER_CONTACT_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* getFilteredBuyerRecordsSaga({ payload: { buyerName } }) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(getFilteredBuyerRecordsRequest, buyerName, idToken);
    yield put({
      type: GET_FILTERED_BUYER_RECORDS_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_FILTERED_BUYER_RECORDS_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* getFilteredSupplierRecordsSaga({ payload: { filterData } }) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      getFilteredSupplierRecordsRequest,
      filterData,
      idToken,
    );
    yield put({
      type: GET_FILTERED_SUPPLIER_RECORDS_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_FILTERED_SUPPLIER_RECORDS_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* addNewHyperLinkSaga({ payload: { data } }) {
  try {
    const idToken = yield getIdToken();
    yield call(addNewHyperlinkRequest, data, idToken);
    yield put({
      type: ADD_NEW_HYPERLINK_SUCCESS,
      payload: { data: 'success' },
    });
  } catch (err) {
    yield put({
      type: ADD_NEW_HYPERLINK_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

export function* getSupplierSecretsSaga({ payload: { supplierId } }) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(getSupplierSecretsRequest, supplierId, idToken);
    yield put({
      type: GET_SUPPLIER_SECRETS_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_SUPPLIER_SECRETS_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

// watchers
export function* getBuyerContactListWatcher() {
  yield takeEvery(GET_BUYER_CONTACT_LIST_REQUESTED, getBuyerContactListSaga);
}

export function* getVaultRequestListWatcher() {
  yield takeEvery(GET_VAULT_REQUEST_LIST_REQUESTED, getVaultRequestListSaga);
}

export function* deleteVaultRequestWatcher() {
  yield takeEvery(DELETE_VAULT_REQUEST_REQUESTED, deleteVaultRequestSaga);
}

export function* deleteBuyerContactWatcher() {
  yield takeEvery(DELETE_BUYER_CONTACT_REQUESTED, deleteBuyerContactSaga);
}

export function* updateVaultRequestWatcher() {
  yield takeEvery(UPDATE_VAULT_REQUEST_REQUESTED, updateVaultRequestSaga);
}

export function* addNewBuyerContactWatcher() {
  yield takeEvery(ADD_NEW_BUYER_CONTACT_REQUESTED, addNewBuyerContactSaga);
}

export function* updateBuyerContactWatcher() {
  yield takeEvery(UPDATE_BUYER_CONTACT_REQUESTED, updateBuyerContactSaga);
}

export function* addNewVaultRequestWatcher() {
  yield takeEvery(ADD_NEW_VAULT_REQUEST_REQUESTED, addNewVaultRequestSaga);
}
export function* addNewHyperLinkWatcher() {
  yield takeEvery(ADD_NEW_HYPERLINK_REQUESTED, addNewHyperLinkSaga);
}

export function* getFilteredBuyerRecordsWatcher() {
  yield takeEvery(
    GET_FILTERED_BUYER_RECORDS_REQUESTED,
    getFilteredBuyerRecordsSaga,
  );
}

export function* getFilteredSupplierRecordsWatcher() {
  yield takeLatest(
    GET_FILTERED_SUPPLIER_RECORDS_REQUESTED,
    getFilteredSupplierRecordsSaga,
  );
}

export function* getSupplierSecretsWatcher() {
  yield takeEvery(GET_SUPPLIER_SECRETS_REQUESTED, getSupplierSecretsSaga);
}
